import { MealOptionsName } from './mealoptions.constants';

export type AmenityName =
  | 'inPolicy'
  | 'wifi'
  | 'accessibleoptions'
  | 'airportshuttle'
  | 'businessservice'
  | 'parking'
  | 'freeparking'
  | 'onsiteparking'
  | 'securedparking'
  | 'evparking'
  | 'freetruckparking'
  | 'truckparking'
  | 'restaurant'
  | 'swimmingpool'
  | 'gym'
  | 'frontdesk'
  | 'breakfast'
  | 'exclusiveRate'
  | 'freecancellation'
  | MealOptionsName.AllBreakfastOptions
  | MealOptionsName.MustIncludeDinner
  | 'loyaltyProgram';

export enum AmenityLabels {
  frontdesk = 'searchableAmenities.frontDesk',
  accessibleoptions = 'searchableAmenities.accessibleOptions',
  breakfast = 'searchableAmenities.breakfast',
  businessservice = 'searchableAmenities.businessService',
  gym = 'searchableAmenities.gym',
  parking = 'searchableAmenities.parkingAvailable',
  freeparking = 'searchableAmenities.freeparking',
  onsiteparking = 'searchableAmenities.onsiteparking',
  securedparking = 'searchableAmenities.securedparking',
  evparking = 'searchableAmenities.evparking',
  freetruckparking = 'searchableAmenities.freetruckparking',
  truckparking = 'searchableAmenities.truckparking',
  restaurant = 'searchableAmenities.restaurant',
  swimmingpool = 'searchableAmenities.swimmingPool',
  wifi = 'searchableAmenities.wifi',
  exclusiveRate = 'searchableAmenities.exclusiveRate',
  inPolicy = 'inPolicyText',
  freecancellation = 'freeCancellation',
  allbreakfastoptions = 'allbreakfastoptions',
  mustincludedinner = 'mustincludedinner',
  loyaltyProgram = 'loyaltyProgram',
}

export const filterTranslationPaths: string[] = [
  AmenityLabels.accessibleoptions,
  AmenityLabels.businessservice,
  AmenityLabels.restaurant,
  AmenityLabels.swimmingpool,
  AmenityLabels.wifi,
  AmenityLabels.frontdesk,
  AmenityLabels.gym,
  AmenityLabels.exclusiveRate,
  AmenityLabels.freecancellation,
];

export const parkingTranslation = AmenityLabels.parking;

export const parkingTranslationPaths: string[] = [
  AmenityLabels.freeparking,
  AmenityLabels.onsiteparking,
  AmenityLabels.securedparking,
  AmenityLabels.evparking,
  AmenityLabels.freetruckparking,
  AmenityLabels.truckparking,

];
